@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.analytics

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.analytics.AnalyticsConfigDto

object GetAnalyticsSettingsEndpoint : EndPoint<GetAnalyticsSettingsEndpoint.Request, GetAnalyticsSettingsEndpoint.Response>() {
    class Request
    class Response(val settings: AnalyticsConfigDto)
}
